import './filters/scripts';
import './productCustomizer/scripts';
import './wishlist/scripts';
